import { MapperHelper } from '@helpers';
import React from 'react';

import styles from './Avatar.module.scss';

interface AvatarProps {
  user: string;
}

export const Avatar: React.FC<AvatarProps> = ({ user }) => (
  <div
    className={styles.avatar}
    style={{ backgroundColor: MapperHelper.stringToHslColor(user, 45, 80) }}
  >
    {user.charAt(0).toUpperCase()}
  </div>
);
